
import React from 'react';
import UnifiedChatInterface from './UnifiedChatInterface';

interface ChatInterfaceProps {
  initialGroupId?: string;
  highlightMessageId?: string;
}

const ChatInterface = ({ initialGroupId, highlightMessageId }: ChatInterfaceProps) => {
  console.log('=== CHAT INTERFACE - USING UNIFIED SYSTEM ===');
  console.log('Initial Group ID:', initialGroupId);
  console.log('Highlight Message ID:', highlightMessageId);
  
  return <UnifiedChatInterface initialGroupId={initialGroupId} highlightMessageId={highlightMessageId} />;
};

export default ChatInterface;
